/**
 * ⚠️  AUTO-GENERATED — DO NOT EDIT MANUALLY ⚠️
 *
 * Generated by: scripts/preload-query-batch-classifier/index.mjs
 *
 * Per-region SSR preloaded GraphQL query classification using bitmap encoding.
 * Q contains all query names (sorted, with index comments). R maps each SSR
 * region to a hex bitmap where bit i = 1 means Q[i] is fast (batchable).
 *
 * Per-region classification summary (fast/slow/excluded counts) is
 * embedded in the PR description.
 *
 * Thresholds (prod): p90 ≤ 300ms | p95 ≤ 500ms | p99 ≤ 1000ms | min n=100
 * Thresholds (staging): p90 ≤ 600ms | p95 ≤ 1000ms | p99 ≤ 2000ms | min n=100
 * Lookback: last 3 business days
 * Generated: 2026-05-20T03:12:24.044Z
 */

// prettier-ignore
export const Q: readonly string[] = [
	'ActiveCommentsQuery', // 0
	'ApprovalsContextApprovalsDataQuery', // 1
	'ArchivedPageBannerV2ArchivedPageBannerContainerQuery', // 2
	'ArchivedPageBannerV2ArchivedPageBannerQuery', // 3
	'BlogTreeRootComponentQuery', // 4
	'CollabDraftQuery', // 5
	'CollabDraftWithRelevanceQuery', // 6
	'ContentBlogUnifiedQuery', // 7
	'ContentHeaderPresenceContentSettingsQuery', // 8
	'ContentHeaderUnifiedQuery', // 9
	'ContentPrerequisitesQuery', // 10
	'ContentRedirectQuery', // 11
	'ContentTypesHeaderQuery', // 12
	'ContentUnifiedQuery', // 13
	'ContentUnifiedWithSpaceKeyQuery', // 14
	'CookieConsentPreferences', // 15
	'CoverPictureQuery', // 16
	'CustomHeaderFooterQuery', // 17
	'DatabaseContainerQuery', // 18
	'EditContentButtonQuery', // 19
	'EditorContentStateQuery', // 20
	'EditorPreferencesQuery', // 21
	'EmojiTitleQuery', // 22
	'EndOfPageRecommendationQuery', // 23
	'FetchPreFilteredForgeAppsQuery_confluence_contentBylineItem', // 24
	'FetchPreFilteredForgeAppsQuery_confluence_spacePage', // 25
	'FetchPreFilteredForgeAppsQuery_xen_macro', // 26
	'FollowingFeedWithSortByStorageSnippetsQuery', // 27
	'FooterCreateButtonsQuery', // 28
	'ForgeExtensionList', // 29
	'GlobalNavigationComponentQuery', // 30
	'GrantAccessDialogLoaderQuery', // 31
	'HomeRecentWorkQuery', // 32
	'InlineCommentsFocusedInlineCommentQuery', // 33
	'LegacyMacroRendererQueryBodyQuery', // 34
	'LivePagesByLineLastUpdatedQuery', // 35
	'LocalStorageQuery', // 36
	'NativeCollabQuery', // 37
	'NotFoundContainerQuery', // 38
	'NotificationsButtonQuery', // 39
	'ObjectCommentContainerPreloadObjectCommentsQuery', // 40
	'PageRestrictionsContextQuery', // 41
	'PageTreeMacroAncestorsQuery', // 42
	'PageTreeMacroChildrenQuery', // 43
	'PageTreeQuery', // 44
	'PageTreeQueryWithSpaceKeyQuery', // 45
	'PermissionCheckAddCommentQuery', // 46
	'PersistentInviteEligibleQuery', // 47
	'PersonalizedTemplatesV2AllTemplatesQuery', // 48
	'PopularFeedWithTimeGranularityStorageSnippetsQuery', // 49
	'Preferences', // 50
	'PremiumTrialEotQuery', // 51
	'ReactionsContentQuery', // 52
	'RecentlyUpdatedMacroQuery', // 53
	'RendererContentStateQuery', // 54
	'RestrictedPageWithCanViewQuery', // 55
	'ScreenQuery', // 56
	'SiteInformationQuery', // 57
	'SmartCreateFeedbackBannerQuery', // 58
	'SmartCreatePageEditorDataWrapperComponentQuery', // 59
	'SpaceNavigationQuery', // 60
	'SpaceOverviewIdQuery', // 61
	'SpaceOverviewQuery', // 62
	'SpaceQuery', // 63
	'SpaceRestrictionCheckQuery', // 64
	'ThemeQuery', // 65
	'TopNavigationQuery', // 66
	'UserSettingsQuery', // 67
	'ViewSpaceExternalCollaboratorsDialogQuery', // 68
	'WebItemLocationQuery_page.metadata.banner', // 69
	'WebItemLocationQuery_system.content.byline', // 70
	'WebItemLocationQuery_system.header_left', // 71
	'WebItemLocationQuery_system.header_left_system.user', // 72
	'WebPanelLocationQuery_atl.footer', // 73
	'WebPanelLocationQuery_atl.general', // 74
	'WebPanelLocationQuery_atl.general_atl.footer', // 75
	'WebPanelLocationQuery_atl.page.content.footer.actions', // 76
	'WebStorageCategories', // 77
	'WelcomeMessagesQuery', // 78
	'WhiteboardUnifiedQuery', // 79
	'bifrost-ssr/prepare/preloadQuery/editor/nodeDataProvidersData/fetch:AdfDocQuery', // 80
	'bifrost-ssr/prepare/preloadQuery/renderer/syncedBlocksData/fetch:SyncBlockReferences', // 81
	'contentAppearanceQuery', // 82
	'contentSmartLinksORS', // 83
	'fetchMentionsProviderDataQuery', // 84
	'graphqlHelpersDSPIsActionEnabledForContentQuery', // 85
	'graphqlHelpersFetchMediaTokenQuery', // 86
	'multiMacroQueryWithAppKeyQuery', // 87
	'onboardingStateGetOnboardingStateQuery', // 88
	'onboardingStateGetOnboardingStateQuery_aifc-onboarding_hasSeenAIFCSpotlight_8', // 89
	'onboardingStateGetOnboardingStateQuery_auto-page-emoji_emojiTitleDiscovered', // 90
	'onboardingStateGetOnboardingStateQuery_create-with-rovo-announcement-splash_hasSeenSplashModal', // 91
	'onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_2', // 92
	'onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_4', // 93
	'onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_6', // 94
	'onboardingStateGetOnboardingStateQuery_cross-join-nth-user-onboarding_trendingPages', // 95
	'onboardingStateGetOnboardingStateQuery_cross-join-nth-user-onboarding_trendingPages_2', // 96
	'onboardingStateGetOnboardingStateQuery_editor-state_editorOnboardingEligiblity_12', // 97
	'onboardingStateGetOnboardingStateQuery_land-users-in-editor-with-revamped-bpqa_revampedBpqaShownAt', // 98
	'onboardingStateGetOnboardingStateQuery_onboarding-intent-experiences_onboardingIntentExperienceClosed_18', // 99
	'onboardingStateGetOnboardingStateQuery_onboarding-origin-state_attributes_66', // 100
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin', // 101
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_10', // 102
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_5', // 103
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_6', // 104
	'onboardingStateGetOnboardingStateQuery_onboarding-state_nthUserOnboardingCompletedTimestamp', // 105
	'onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_151', // 106
	'onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_152', // 107
	'onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_153', // 108
	'onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_154', // 109
	'pageButtons', // 110
	'preloadAutohighlightsQuery', // 111
	'preloadContentSmartLinksQuery', // 112
	'preloadCreateSpaceQuery', // 113
	'preloadEditButtonWithSpaceKeyQuery', // 114
	'preloadEditorNodeDataProvidersDataQuery', // 115
	'preloadLegacyBridgeQuery', // 116
	'preloadOperationsQuery', // 117
	'preloadPageStatusQueryDataQuery', // 118
	'preloadPersonalSpaceDetailsQuery', // 119
	'preloadShareAndRestrictButtonQuerySpaceOverviewQuery', // 120
	'preloadSpaceBlogCountQuery', // 121
	'preloadTemplatesCollectionEligibleQuery', // 122
	'requireSuperBatchFrontendResourceRenderQuery', // 123
	'rightPanel', // 124
	'searchCombinedConfig', // 125
	'searchResults', // 126
	'sidenavSmartLinksORS', // 127
	'ssr-app/prepare/preloadQuery/editor/nodeDataProvidersData/fetch:AdfDocQuery', // 128
	'useAnalyticsByLineQuery', // 129
	'useAudioContentQuery', // 130
	'useBlogPostsQueryQuery', // 131
	'useConfluenceStandardToPremiumExperimentQuery', // 132
	'useContentByLabelDataQuery', // 133
	'useContentClassificationContentDataClassificationQuery', // 134
	'useEditorContentModeValueQuery', // 135
	'useEmojiEverSetPropertyQuery', // 136
	'useFabricEligibilityMigrationQuery', // 137
	'useFeatureDiscoveryFeatureDiscoveryQuery', // 138
	'useFeedTypeSelectorRefreshQuery', // 139
	'useFollowingFeedWithSortByStorageFeedContentQuery', // 140
	'useGetCurrentStorageUsageQuery', // 141
	'useGetTeamAndSubanchorGetPersonalSpaceKeyQuery', // 142
	'useGetTeamAndSubanchorGetSubanchorsAGGQuery', // 143
	'useHomeWidgetStateQuery', // 144
	'useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery', // 145
	'useIsLoomEntryPointsEnabledQuery', // 146
	'useIsUserViewingSpaceAsAnonQuery', // 147
	'useLicensedProductsQueryForGlobalAppShortcutsQuery', // 148
	'useLoomTenantProvisionStatusQuery', // 149
	'usePopularFeedWithTimeGranularityStorageQuery', // 150
	'usePreloadCommentButtonQuery', // 151
	'useReadTimeQuery', // 152
	'useRegisterAdminAnnouncementBannerQuery', // 153
	'useShareAndRestrictButtonDataQuery', // 154
	'useShortcutsSpaceNavigationQuery', // 155
	'useSpaceBaseQueryBaseQuery', // 156
	'useSpaceDetailQuery', // 157
	'useSpaceEnabledContentTypesQuery', // 158
	'useSpaceViewsDataSpaceRootQuery', // 159
	'useSpaceViewsOptionsPersistenceQuery', // 160
	'useSpacesDataAnonymousSpacesQuery', // 161
	'useSpacesDataMyVisitedSpacesQuery', // 162
	'useSpacesDataStarredSpacesQuery', // 163
	'useTitleContentPropertiesForEditorQuery', // 164
	'useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery', // 165
	'useTitleContentPropertiesForPublishedPageQuery', // 166
	'useUserByLicensedProductsQuery', // 167
];

// prettier-ignore
export const R: Readonly<Record<string, string>> = {
	'prod-apne': '9dff7b77fa73cdffffb6f5cfffffff5fd5cfbdfff9', /* 135 fast, 16 slow, 7 excl */
	'prod-apne2': 'b5ff7bf7fa73cdffffb6f5cff7ffff13d5efbdff79', /* 132 fast, 18 slow, 48 excl */
	'prod-apse': 'bdff7bf7fb73ddffffb6f5cfffffff5fd5efbdfffb', /* 141 fast, 13 slow, 55 excl */
	'prod-apse2': 'bdff7bf7fa73ddfffff6f5cfffffff5fd7efbdffff', /* 143 fast, 11 slow, 54 excl */
	'prod-apsouth': 'bdff7b77fa73cdffffd6f5cfffffff57d7eebdfffd', /* 137 fast, 12 slow, 11 excl */
	'prod-cacentral': '3dff7b77fbf3ddfffff6f5cfffffff57d7efbffffd', /* 142 fast, 7 slow, 10 excl */
	'prod-east': '9dff7ff7fbf3ddfffff6f5efffffff7fd5efbfffff', /* 147 fast, 10 slow, 51 excl */
	'prod-eucentral': '9fff7ff7fa53ddffffb6f5efffffff5fd5efbdffff', /* 142 fast, 15 slow, 98 excl */
	'prod-eucentral2': 'b5df7b37f873ddf7ff9475cff6fbff05d5efbdff79', /* 122 fast, 22 slow, 15 excl */
	'prod-euwest': 'bfff7ff7fbf3ddfffff6f5efffffff5fd5efbfffff', /* 148 fast, 10 slow, 114 excl */
	'prod-euwest2': 'bdff7bf7fbf3ddfffff6f5cffeffff57d7efbffffd', /* 143 fast, 7 slow, 11 excl */
	'prod-west2': '9dff7ff7fef3ddfffff6f5efffffff5fd7efbfffff', /* 147 fast, 9 slow, 116 excl */
	'stg-east': 'f6f7fb37f8fff577ff5ff5dfefc3ffd7f6efbfffff', /* 138 fast, 9 slow, 52 excl */
};
